import { useConnection } from "@/components/features/items/edit/_shared/ui/components/main/questions/connection/hooks";

import { useProductDayTripPlanFormModelContext } from "../../../../../context";

export const usePlanAvailableOptionIDs = () => {
	const { viewModel, onSetViewModel, queryData } = useProductDayTripPlanFormModelContext();
	const { availableOptionIDs } = viewModel;
	const { optionNameAndIDOptions } = queryData.connection;

	return useConnection<"availableOptionIDs">({
		availableItemIDs: availableOptionIDs, //
		nameAndIDOptions: optionNameAndIDOptions,
		keyOfValue: "availableOptionIDs",
		onSetViewModel,
	});
};
